/* Lab reports page - sections/lab-page-reports.liquid.
   - Custom dropdowns (button + listbox) for product and batch: a native
     <select> popup cannot be styled dark (same call as the PDP lab modal).
   - Picking a product shows that product's batch dropdown and its newest
     batch; picking a batch shows that batch's reports (strict, like the PDP).
   - ?product=<handle> preselects a product, so other pages can link in.
   - The "what we test" tabs swap the statement photo and text.
   - The quality standards row (sections/lab-page-standards.liquid) swipes
     below 990px; its arrows step one card and wrap round like the product
     page carousels.
   Both sections load this file, so it runs once.
   Everything is rendered server-side for the first product, so the page
   reads correctly without this script. */
(function () {
  if (window.lrpLabPage) return;
  window.lrpLabPage = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTrack(track) {
    if (track.hasAttribute('data-lrp-ready')) return;
    track.setAttribute('data-lrp-ready', '');
    var frame = track.parentElement;
    var items = Array.prototype.slice.call(track.children);
    var behavior = reduced ? 'auto' : 'smooth';

    function step(direction) {
      var max = track.scrollWidth - track.clientWidth;
      if (items.length < 2 || max <= 2) return;
      var current = track.scrollLeft;
      if (direction > 0 && current >= max - 2) return track.scrollTo({ left: 0, behavior: behavior });
      if (direction < 0 && current <= 2) return track.scrollTo({ left: max, behavior: behavior });
      var target = null;
      for (var i = 0; i < items.length; i++) {
        var left = items[i].offsetLeft - items[0].offsetLeft;
        if (direction > 0 && left > current + 2) { target = left; break; }
        if (direction < 0 && left < current - 2) target = left;
      }
      if (target === null) target = direction > 0 ? max : 0;
      track.scrollTo({ left: Math.min(max, target), behavior: behavior });
    }
    var prev = frame.querySelector('[data-lrp-prev]');
    var next = frame.querySelector('[data-lrp-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function initSelect(box, onPick) {
    var toggle = box.querySelector('[data-lrp-select-toggle]');
    var menu = box.querySelector('[data-lrp-select-menu]');
    var label = box.querySelector('[data-lrp-select-label]');
    if (!toggle || !menu) return null;

    function setOpen(open) {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      box.classList.toggle('is-open', open);
    }
    function pick(opt, silent) {
      box.setAttribute('data-value', opt.getAttribute('data-value'));
      label.textContent = opt.textContent;
      menu.querySelectorAll('[data-lrp-select-option]').forEach(function (o) {
        var active = o === opt;
        o.classList.toggle('is-active', active);
        o.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (!silent) onPick(opt.getAttribute('data-value'));
    }

    toggle.addEventListener('click', function () {
      if (menu.querySelectorAll('[data-lrp-select-option]').length < 2) return;
      setOpen(menu.hidden);
      if (!menu.hidden) {
        var current = menu.querySelector('.is-active') || menu.querySelector('[data-lrp-select-option]');
        if (current) current.focus();
      }
    });
    menu.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-lrp-select-option]');
      if (!opt) return;
      pick(opt);
      setOpen(false);
      toggle.focus();
    });
    menu.addEventListener('keydown', function (event) {
      var opts = Array.prototype.slice.call(menu.querySelectorAll('[data-lrp-select-option]'));
      var i = opts.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        var next = event.key === 'ArrowDown' ? Math.min(i + 1, opts.length - 1) : Math.max(i - 1, 0);
        opts[next].focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!box.contains(event.target)) setOpen(false);
    });
    box.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || menu.hidden) return;
      event.stopPropagation();
      setOpen(false);
      toggle.focus();
    });

    return {
      select: function (value) {
        var opt = menu.querySelector('[data-lrp-select-option][data-value="' + CSS.escape(value) + '"]');
        if (opt) pick(opt, true);
      },
      first: function () {
        var opt = menu.querySelector('[data-lrp-select-option]');
        return opt ? opt.getAttribute('data-value') : '';
      }
    };
  }

  function initReports(root) {
    if (root.dataset.lrpInit) return;
    root.dataset.lrpInit = 'true';

    var reports = root.querySelectorAll('[data-lrp-report]');
    var batchBoxes = root.querySelectorAll('[data-lrp-batch]');
    var batchSelects = {};
    var state = { product: '', batch: '' };

    function apply() {
      reports.forEach(function (el) {
        var sameProduct = el.getAttribute('data-product') === state.product;
        var batch = el.getAttribute('data-batch') || '';
        el.hidden = !sameProduct || (state.batch !== '' && batch !== state.batch);
      });
    }
    function showProduct(handle) {
      state.product = handle;
      state.batch = '';
      batchBoxes.forEach(function (box) {
        var mine = box.getAttribute('data-product') === handle;
        box.hidden = !mine;
        if (mine && batchSelects[handle]) {
          state.batch = batchSelects[handle].first();
          batchSelects[handle].select(state.batch);
        }
      });
      apply();
    }

    batchBoxes.forEach(function (box) {
      batchSelects[box.getAttribute('data-product')] = initSelect(box, function (value) {
        state.batch = value;
        apply();
      });
    });

    var productBox = root.querySelector('[data-lrp-product]');
    var productSelect = productBox && initSelect(productBox, showProduct);
    var initial = productBox ? productBox.getAttribute('data-value') : '';
    try {
      var wanted = new URLSearchParams(window.location.search).get('product');
      if (wanted && productBox && productBox.querySelector('[data-lrp-select-option][data-value="' + CSS.escape(wanted) + '"]')) {
        initial = wanted;
        productSelect.select(wanted);
      }
    } catch (e) { /* old browsers keep the first product */ }
    showProduct(initial);

    var statement = root.querySelector('[data-lrp-statement]');
    var statementText = root.querySelector('[data-lrp-statement-text]');
    var tabs = root.querySelectorAll('[data-lrp-tab]');
    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-lrp-tab]');
      if (!tab || !statement) return;
      tabs.forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      var image = tab.getAttribute('data-image');
      if (image) statement.style.backgroundImage = 'url(' + image + ')';
      if (statementText) {
        var html = '';
        try { html = JSON.parse(tab.getAttribute('data-text') || '""'); } catch (e) { html = ''; }
        statementText.innerHTML = html;
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-lrp-reports-root]').forEach(initReports);
    document.querySelectorAll('[data-lrp-track]').forEach(initTrack);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
